import { V1, serializeQueryString } from 'Util/fetcher';

// Account
//

// https://ajaib.readme.io/reference/margin-account-status-trade
export const mtAccountStatusUrl = `${V1}stock/mt/status/trade/`;

// https://ajaib.readme.io/reference/margin-ratio
export const mtMarginRatioUrl = `${V1}mt/marginratio/user`;

// https://ajaib.readme.io/reference/tradelimit-margin
export const mtTradelimitByStockCodeUrl = (code) =>
  `${V1}stock/mt/tradelimit/${serializeQueryString({ ticker_code: code })}`;

// Config
//

// https://ajaib.readme.io/reference/margin-tradeable
export const mtEnabledByStockCodeUrl = (code) => `${V1}stock/detail/${code}/margin-tradeable`;

// Trading
//

/**
 * - Buy:       https://ajaib.readme.io/reference/buy-margin-stock
 * - Sell:      https://ajaib.readme.io/reference/sell-margin-stock
 * - Amend:     https://ajaib.readme.io/reference/amend-margin-stock
 * - Withdraw:  https://ajaib.readme.io/reference/withdraw-margin-order
 *
 * @param {'buy'|'sell'|'amend'|'withdraw'} type
 */
export const mtPostOrderUrl = (type) => `${V1}stock/mt/${type}/`;

// Portfolio
//

// https://ajaib.readme.io/reference/portfolio-margin-account
export const mtPortfolioListUrl = `${V1}stock/mt/portfolio/`;
// ??
export const mtOrderOpenUrl = `${V1}stock/mt/orderlist-filter/`;
// ??
export const mtOrderHistoryUrl = `${V1}stock/mt/historytrade-filter/`;
